import React, { useMemo } from 'react';
import { Marker } from 'react-leaflet';
import { Sample } from 'src/shared/types';
import { getMapMarkerIcon } from 'src/shared/components/map-marker-icon';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';

type Props = {
    samples: Pick<Sample, 'sampleId' | 'location' | 'covariates'>[];
};

const SpeciesMiniMapMarkers = (props: Props) => {
    const { samples } = props;

    const { getColourForArea } = useProjectFilters();

    const points = useMemo(
        () =>
            (samples || [])
                .filter(s => Array.isArray(s.location?.coordinates) && s.location.coordinates.length >= 2)
                .map(s => {
                    const siteName = s.covariates?.find(c => c.covariateKey === 'site')?.covariateValue || '';
                    const color = getColourForArea(siteName);
                    return {
                        id: s.sampleId,
                        lat: Number(s.location.coordinates[0]),
                        lng: Number(s.location.coordinates[1]),
                        color,
                    };
                }),
        [samples, getColourForArea]
    );

    return (
        <>
            {points.map((p, index) => (
                <Marker
                    key={`${p.id || 'sample'}-${index}`}
                    position={[p.lat, p.lng]}
                    icon={getMapMarkerIcon({
                        color: p.color,
                        groupOrder: 0,
                    })}
                />
            ))}
        </>
    );
};

export default SpeciesMiniMapMarkers;
